import React, { useState, Fragment } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { host } from '../../../configuraciones';
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux'
import { actualizarDatosCertificadoFC13, actualizarDatosConstanciaFC27 } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  height: '85%',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  'overflowY': 'scroll',
};
function PDFViewer(props) {

  const dispatch = useDispatch()

  const [observaciones, setObservaciones] = useState(props?.data?.observaciones != null ? props?.data?.observaciones : '');

  //<BotonVerDictamenesComponent tabla={'documentodictamenfiscal'} nombreId={'idcliente'} idSolicitud={10} />
  const [url, setUrl] = React.useState('')

  React.useEffect(async () => {

    if (props.data.tabla != null && props.data.tabla != undefined) {
      try {
        await dispatch(actualizarLoadingApp_true())
        const response = await fetch(host + `SolicitudesEstatus/servirCertificado/tabla=${props?.data?.tabla}&idname=${props?.data?.idname}&id=${props?.data?.id}`);
        if (response.status === 200) {
          const blob = await response.blob();
          const url1 = URL.createObjectURL(blob);
          setUrl(url1);
        }
        await dispatch(actualizarLoadingApp_false())
      } catch (error) {
        console.error('Error al cargar el PDF:', error);
      }
    }

  }, [props?.data])

  const [openModal, setOpenModal] = React.useState(true);
  const handleCloseModal = () => {
    setOpenModal(false)
    props.setOpenModal(false)
  }

  const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    height: 250,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px'
  };
  const theme = createTheme({
    palette: {
      primary: {
        main: "#EDB75A"
      },
      secondary: {
        main: "#DC3545"
      }
    },
    typography: {
      fontFamily: "Montserrat",
      textTransform: 'none',
      button: {
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Montserrat",
        textTransform: 'none'
      }
    }
  });
  const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
  const handleOpenModalAceptar = () => { setOpenModalAceptar(true) }
  const handleCloseModalAceptar = () => { setOpenModalAceptar(false) }
  const modalComponentAceptar = () => {
    return (
      <div>
        <Modal open={openModalAceptar} onClose={handleCloseModalAceptar} aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style1}>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
              <h3 className='text-center'><b>ADVERTENCIA</b></h3>
              <p className='mt-3'>¿Está seguro que el certificado se encuentra con datos correctos.?</p>
            </Typography>
            <br />
            <ThemeProvider theme={theme}>
              <div className='row'>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModalAceptar() }}>Cancelar</Button>
                </div>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                </div>
              </div>
            </ThemeProvider>
          </Box>
        </Modal>
      </div>
    )
  }
  const btnContinuar = async () => {
    if (props?.data?.tabla == 'ocsolicitudfc01_fc13_documento') {
      let data = { idsolicitudesocfc13: props?.data?.id, observacionesbeneficiario: observaciones, idestatuspdfoc: 4 }
      await dispatch(actualizarDatosCertificadoFC13(data))
    }
    if (props?.data?.tabla == 'ocsolicitudfc01_fc27_documento') {
      let data = { idsolicitudesocfc27: props?.data?.id, observacionesbeneficiario: observaciones, idestatuspdfoc: 4 }
      await dispatch(actualizarDatosConstanciaFC27(data))
    }
    handleCloseModalAceptar()
    props?.setOpenModal(false)
  }
  const [openModalCorregir, setOpenModalCorregir] = React.useState(false);
  const handleOpenModalCorregir = () => { setOpenModalCorregir(true) }
  const handleCloseModalCorregir = () => { setOpenModalCorregir(false) }
  const modalComponentCorregir = () => {
    return (
      <div>
        <Modal open={openModalCorregir} onClose={handleCloseModalCorregir} aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style1}>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
              <h3 className='text-center'><b>ADVERTENCIA</b></h3>
              <p className='mt-3'>¿Se devolverá el certificado para corrección con las observaciones agregadas?</p>
            </Typography>
            <br />
            <ThemeProvider theme={theme}>
              <div className='row'>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModalCorregir() }}>Cancelar</Button>
                </div>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnCorregir() }}>Continuar</Button>
                </div>
              </div>
            </ThemeProvider>
          </Box>
        </Modal>
      </div>
    )
  }
  const btnCorregir = async () => {
    if (props?.data?.tabla == 'ocsolicitudfc01_fc13_documento') {
      let data = { idsolicitudesocfc13: props?.data?.id, observacionesbeneficiario: observaciones, idestatuspdfoc: 3 }
      await dispatch(actualizarDatosCertificadoFC13(data))
    }
    if (props?.data?.tabla == 'ocsolicitudfc01_fc27_documento') {
      let data = { idsolicitudesocfc27: props?.data?.id, observacionesbeneficiario: observaciones, idestatuspdfoc: 3 }
      await dispatch(actualizarDatosConstanciaFC27(data))
    }
    handleCloseModalCorregir()
    props?.setOpenModal(false)
  }
  return (
    <div>
      <Fragment>
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description" >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `} style={{ textAlign: 'center' }}>
                <h3><strong>CERTIFICADO</strong></h3>
              </div>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
              <div className='row mt-2 mb-3'>
                <TextField id="filled-textarea" label="Observaciones" placeholder="" multiline
                  variant="filled" value={observaciones} onChange={e => setObservaciones(e.target.value)} />
                <div className='mt-3'>
                  {url && <embed src={url} type="application/pdf" width="100%" height="500" />}
                </div>
                <button className='btn btn-success col mt-3' onClick={() => handleOpenModalAceptar()}>Aceptar</button>
                <button className='btn btn-danger col mt-3' onClick={() => handleOpenModalCorregir()}>Corregir</button>
                {/*<Document file={url}>
                  <Page pageNumber={1} hideToolbar />
                </Document>*/}
              </div>
            </Typography>
            <br />
          </Box>
        </Modal>
        {modalComponentAceptar()}
        {modalComponentCorregir()}
      </Fragment>

    </div>
  );
}

export default PDFViewer;
